export {
  type ComfortInput,
  type ComfortResult,
  type ComfortRuimteInput,
  type RuimteLastRow,
  type RuimtePositie,
  type GebouwIntensiteit,
  type ThermalLineItem,
  type ScenarioOutput,
  type ClimateContextMeta,
  type OpenMeteoClimatePayload,
  type ComfortEngineInsights,
  type UserSegment,
  type TechniekAdviesRegel,
  type TechniekAdviesCategorie,
  type TypeDak,
  type TypeGlas,
  type TypeWoning,
  TYPE_WONING_LABELS,
  isResidentialTypeWoning,
  isAppartementachtigGebouw,
  type OrientatieRamen,
  type Zonwering,
  type IsolatieProfiel,
  type RenovatieScenario,
  type Luchtdichtheid,
  type ComfortSituatieInput,
  type ComfortWensenInput,
  type MeterkastStatus,
  type WaterWarmtepompDichtbij,
  type BestaandeVerwarming,
  type PandGebruik,
  type KlusOmvang,
  type WarmteVoorkeur,
  segmentRegelgevingKortText,
  COMFORT_ENGINE_VERSION,
  ASSUMPTION_SET_ID,
  NL_INTERIOR_DEGREE_DAY_REF,
  USER_SEGMENT_LABELS,
  RUIMTE_POSITIE_LABELS,
  JIP_EN_JANNEKE_LEGEND,
  validateComfortInput,
  normalizeComfortInput,
  computeComfortEngine,
  computeComfortAdvice,
  applyClimateYearlyToResult,
  type BuildingLinearThermalCoeffs,
  type HourlyIdealLoadParams,
  type HourlyIdealLoadResult,
  type HourlyOutdoorSeries,
  computeBuildingLinearThermalCoeffs,
  runHourlyIdealLoadSimulation,
  simulateHourlyIdealLoads,
  hourlyQuasiSteadySelfCheck,
  ENGINE_TRANSPARENCY_BULLETS,
  type HourlyThermalMeta,
  type ThermalInertiaClass,
} from '@comforttool/comfortcore';

import type { ComfortInput, ComfortResult } from '@comforttool/comfortcore';
import {
  COMFORT_ENGINE_VERSION,
  computeComfortEngine,
  normalizeComfortInput,
} from '@comforttool/comfortcore';

const STORAGE_KEY = 'comforttool_v2_state';

export function persistComfortState(input: ComfortInput, result: ComfortResult): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ input, result, savedAt: new Date().toISOString() }));
  } catch {
    /* ignore */
  }
}

export function loadComfortState(): { input: ComfortInput; result: ComfortResult | null } | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const j = JSON.parse(raw) as { input?: Partial<ComfortInput>; result?: ComfortResult | null };
    const input = normalizeComfortInput(j.input ?? {});
    let result = j.result ?? null;
    if (result && result.engineVersion !== COMFORT_ENGINE_VERSION) {
      result = computeComfortEngine(input);
    }
    return { input, result };
  } catch {
    return null;
  }
}

export function loadComfortInput(): ComfortInput | null {
  const s = loadComfortState();
  return s?.input ?? null;
}

/** Startwaarden voor de scan (wizard) */
export function defaultComfortInput(): ComfortInput {
  return normalizeComfortInput({});
}
